import { useState } from 'react';
import { Tooltip, Box } from '@mui/material';

type CopyEmailWrapperProps = {
  children: React.ReactNode;
};

const PERSONAL_EMAIL = 'albertjlay@gmail.com';
const CopyEmailWrapper = ({ children }: CopyEmailWrapperProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(PERSONAL_EMAIL);
      setIsOpen(true);
      setTimeout(() => setIsOpen(false), 1500);
    } catch (err) {
      window.location.href = `mailto:${PERSONAL_EMAIL}`;
    }
  };

  return (
    <Tooltip
      title='Email Copied'
      open={isOpen}
      placement='top'
      arrow
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'success.main',
            '& .MuiTooltip-arrow': {
              color: 'success.main',
            },
          },
        },
      }}
    >
      <Box
        component='span'
        onClick={handleClick}
        sx={{ display: 'inline-block', cursor: 'pointer' }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default CopyEmailWrapper;
